export const categories = [
  {
    id: 'profile',
    name: '个人资料',
    slug: 'profile',
    description: '桥本有菜的详细个人资料、身高体重、兴趣爱好等基本信息',
    icon: 'ri-user-heart-line',
  },
  {
    id: 'debut',
    name: '出道经历',
    slug: 'debut',
    description: '桥本有菜的出道历程、转折点与成长故事',
    icon: 'ri-star-line',
  },
  {
    id: 'works',
    name: '代表作品',
    slug: 'works',
    description: '桥本有菜的影视作品合集与详细介绍',
    icon: 'ri-movie-line',
  },
  {
    id: 'photobook',
    name: '写真集',
    slug: 'photobook',
    description: '桥本有菜的写真集作品，高清图集与发行信息',
    icon: 'ri-camera-line',
  },
  {
    id: 'news',
    name: '最新动态',
    slug: 'news',
    description: '桥本有菜的最新消息、活动资讯与社交媒体更新',
    icon: 'ri-flashlight-line',
  },
  {
    id: 'community',
    name: '粉丝社区',
    slug: 'community',
    description: '桥本有菜粉丝交流、应援活动与社区动态',
    icon: 'ri-heart-pulse-line',
  },
];

export const articles = [
  {
    id: 'article-1',
    title: '桥本有菜完整个人资料：从出身到现在的演艺之路',
    slug: 'hashimoto-arina-full-profile',
    category: 'profile',
    excerpt: '桥本有菜（橋本ありな），1996年12月15日出生于日本东京都，身高166cm，凭借清纯甜美的外表与出色的演技，成为了日本娱乐圈备受瞩目的新生代女演员。',
    content: `<p>桥本有菜（橋本ありな），1996年12月15日出生于日本东京都，是一位备受瞩目的日本女演员与偶像。身高166cm的她，凭借清纯甜美的外表与出色的演技，迅速在日本娱乐圈崭露头角。</p>
    <h2>基本信息</h2>
    <ul>
      <li><strong>日文名：</strong>橋本ありな（Hashimoto Arina）</li>
      <li><strong>中文名：</strong>桥本有菜</li>
      <li><strong>出生日期：</strong>1996年12月15日</li>
      <li><strong>出生地：</strong>日本东京都</li>
      <li><strong>身高：</strong>166cm</li>
      <li><strong>三围：</strong>83-56-84 cm</li>
      <li><strong>血型：</strong>A型</li>
      <li><strong>爱好：</strong>料理、阅读、旅行</li>
      <li><strong>特长：</strong>钢琴、舞蹈</li>
    </ul>
    <h2>性格特点</h2>
    <p>桥本有菜以其温柔可亲的性格赢得了大量粉丝的喜爱。她在综艺节目中展现出的真实、自然的一面，加上标志性的甜美笑容，让她成为了日本娱乐圈中不可多得的全能艺人。她的粉丝群体横跨多个年龄段，在社交媒体上拥有极高的人气。</p>
    <h2>个人魅力</h2>
    <p>除了出众的外表条件，桥本有菜还具备深厚的艺术修养。从小学习钢琴的她，在音乐方面有着独特的感悟力。她的舞蹈功底也为她在舞台表演中增添了不少亮点。无论是在镜头前的专业表现，还是在生活中的亲和力，都让桥本有菜成为了当之无愧的"国民偶像"。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20woman%20portrait%20in%20soft%20warm%20lighting%2C%20minimalist%20studio%20background%20with%20gentle%20cream%20and%20beige%20tones%2C%20natural%20beauty%2C%20delicate%20expression%2C%20professional%20photography%20style%2C%20soft%20focus%20aesthetic&width=800&height=500&seq=article-profile-01&orientation=landscape',
    date: '2026-08-01',
    tags: ['个人资料', '桥本有菜', '日本女演员', '偶像'],
    featured: true,
  },
  {
    id: 'article-2',
    title: '桥本有菜出道经历全回顾：从新人到顶流的蜕变之路',
    slug: 'hashimoto-arina-debut-story',
    category: 'debut',
    excerpt: '回顾桥本有菜从2015年出道至今的完整历程，看她是如何一步步从新人成长为日本娱乐圈顶级偶像的蜕变之路。',
    content: `<p>桥本有菜的出道经历堪称日本娱乐圈的一段传奇。2015年，年仅19岁的她以新人身份正式出道，凭借独特的清纯气质迅速吸引了大量关注。</p>
    <h2>出道初期（2015-2016）</h2>
    <p>2015年，桥本有菜在东京的一次选拔活动中被星探发掘。凭借着清新脱俗的外形条件和自然的表现力，她很快签约了知名经纪公司，开始了专业的演艺训练。经过数月的密集培训后，她正式在日本娱乐圈亮相。</p>
    <h2>上升期（2017-2018）</h2>
    <p>2017年是桥本有菜事业的一个重要转折点。这一年，她凭借多部优秀作品获得了业界广泛认可。她在作品中展现出的演技进步和对角色的理解力，让观众看到了她作为演员的无限潜力。同年，她开始接到更多商业代言和综艺节目的邀约。</p>
    <h2>爆发期（2019-2020）</h2>
    <p>2019年，桥本有菜迎来了事业的全面爆发。她不仅作品数量大幅增加，更重要的是作品质量得到了业界和粉丝的一致好评。她在社交媒体上的关注度也达到了新的高度，Instagram粉丝突破百万，成为了名副其实的顶流偶像。</p>
    <h2>成熟期（2021至今）</h2>
    <p>进入2021年后，桥本有菜的事业进入了更加成熟的阶段。她开始尝试更多元化的发展方向，包括写真集出版、品牌合作、粉丝见面会等。她在演艺道路上不断突破自我，展现出了一位成熟艺人的专业素养和魅力。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Artistic%20spotlight%20on%20stage%20with%20warm%20golden%20lighting%2C%20elegant%20atmosphere%2C%20soft%20dramatic%20shadows%2C%20minimalist%20composition%2C%20cream%20and%20champagne%20tones%2C%20theatrical%20aesthetic&width=800&height=500&seq=article-debut-01&orientation=landscape',
    date: '2026-07-28',
    tags: ['出道经历', '桥本有菜', '演艺之路', '蜕变'],
    featured: true,
  },
  {
    id: 'article-3',
    title: '桥本有菜代表作品精选：必看的经典之作',
    slug: 'hashimoto-arina-best-works',
    category: 'works',
    excerpt: '精选桥本有菜出道至今最具代表性的影视作品，从早期青涩到成熟演技，带你回顾她的荧幕经典。',
    content: `<p>桥本有菜出道多年，参演了大量优秀的影视作品。以下是我们为大家精选的桥本有菜最具代表性的经典之作，从不同的作品中可以感受到她作为演员的成长与蜕变。</p>
    <h2>早期代表作</h2>
    <p>桥本有菜在出道初期就以清纯甜美的形象赢得了观众的喜爱。她早期的作品充满了青春活力，展现出了一个新人演员的无限可能。</p>
    <h2>中期突破之作</h2>
    <p>随着经验的积累，桥本有菜在作品中展现出了更加成熟的一面。她开始尝试不同类型的角色，演技也愈发精湛。这个时期的作品是她从偶像向实力派演员转型的关键一步。</p>
    <h2>近期经典</h2>
    <p>近年来，桥本有菜的作品更加多元化和高质量。她与多位知名导演和演员合作，创作出了一系列备受好评的经典作品。无论是剧情片还是文艺片，她都能够游刃有余地驾驭。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20spotlight%20composition%2C%20warm%20golden%20and%20rose%20tones%2C%20elegant%20movie%20theater%20aesthetic%2C%20soft%20lighting%2C%20minimalist%20design%2C%20artistic%20film%20photography%20style&width=800&height=500&seq=article-works-01&orientation=landscape',
    date: '2026-07-25',
    tags: ['代表作品', '桥本有菜', '影视作品', '经典'],
    featured: false,
  },
  {
    id: 'article-4',
    title: '桥本有菜最新写真集《花季》全面解读',
    slug: 'hashimoto-arina-photobook-flower-season',
    category: 'photobook',
    excerpt: '桥本有菜最新写真集《花季》正式发售！本写真集在京都拍摄，融合了古都风情与桥本有菜的独特魅力。',
    content: `<p>桥本有菜最新写真集《花季》于2026年夏季正式发售。这本写真集在历史悠久的文化古都京都取景拍摄，将千年古都的风情与桥本有菜的现代魅力完美融合。</p>
    <h2>拍摄背景</h2>
    <p>《花季》的拍摄历时三个月，足迹遍布京都的各个名胜古迹。从岚山的竹林小径到金阁寺的倒影池畔，从伏见稻荷的千本鸟居到祇园的石板路，每一个场景都精心挑选，力求呈现最美的画面。</p>
    <h2>风格特色</h2>
    <p>本次写真集以"花与少女"为主题，展现了桥本有菜从少女到成熟女性的多样化魅力。摄影师使用了自然光与柔焦技术，营造出梦幻般的视觉效果。每一张照片都仿佛一幅精美的画作。</p>
    <h2>发售信息</h2>
    <p>《花季》写真集于2026年7月15日正式发售，限量版附赠签名明信片与幕后花絮DVD。建议零售价：3,800日元（普通版）/ 5,800日元（限量版）。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20style%20photo%20album%20with%20cherry%20blossom%20petals%2C%20soft%20pink%20and%20cream%20tones%2C%20minimalist%20flat%20lay%20composition%2C%20delicate%20aesthetic%2C%20warm%20natural%20lighting%2C%20artistic%20book%20design&width=800&height=500&seq=article-photobook-01&orientation=landscape',
    date: '2026-07-20',
    tags: ['写真集', '花季', '桥本有菜', '京都'],
    featured: true,
  },
  {
    id: 'article-5',
    title: '桥本有菜2026年夏季活动日程与最新动态',
    slug: 'hashimoto-arina-summer-2026-schedule',
    category: 'news',
    excerpt: '桥本有菜2026年夏季活动安排公布！包括粉丝见面会、新作品发布、综艺节目出演等多项精彩内容。',
    content: `<p>2026年夏季，桥本有菜将迎来一系列精彩纷呈的活动安排。从粉丝见面会到新作品发布，从综艺节目到品牌活动，让我们一起来看看这个夏天桥本有菜的最新动态。</p>
    <h2>粉丝见面会</h2>
    <p>桥本有菜2026夏季粉丝见面会将于8月在东京、大阪、名古屋三地举办。这是时隔两年后再次举办的大型粉丝活动，届时将有签名会、互动游戏、限定周边发售等精彩环节。</p>
    <h2>新作品发布</h2>
    <p>据官方消息，桥本有菜将于今年秋季发布全新作品。制作团队阵容豪华，备受粉丝期待。具体详情将于8月中旬的新闻发布会上揭晓。</p>
    <h2>综艺节目</h2>
    <p>桥本有菜将在多档人气综艺节目中担任嘉宾，展现她不为人知的真实一面。其中包括美食节目、旅行节目和谈话节目的录制。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20event%20stage%20with%20warm%20spotlight%20and%20elegant%20decor%2C%20soft%20gold%20and%20cream%20tones%2C%20minimalist%20concert%20venue%2C%20atmospheric%20lighting%2C%20professional%20event%20photography&width=800&height=500&seq=article-news-01&orientation=landscape',
    date: '2026-08-08',
    tags: ['最新动态', '桥本有菜', '粉丝见面会', '2026'],
    featured: true,
  },
  {
    id: 'article-6',
    title: '桥本有菜粉丝社区：加入我们，一起支持最爱的偶像',
    slug: 'hashimoto-arina-fan-community',
    category: 'community',
    excerpt: '桥本有菜官方粉丝社区正式上线！这里汇聚了来自世界各地的粉丝，一起分享应援心得、交流最新资讯。',
    content: `<p>桥本有菜官方粉丝社区是一个为全世界粉丝打造的交流平台。在这里，你可以找到志同道合的朋友，分享你对桥本有菜的喜爱与支持。</p>
    <h2>社区功能</h2>
    <p>粉丝社区提供了丰富的功能：最新资讯推送、粉丝作品展示、应援活动组织、独家幕后花絮分享等。注册成为会员后，还可以参与抽奖活动，赢取桥本有菜的限定周边。</p>
    <h2>应援活动</h2>
    <p>社区定期组织线上线下应援活动。从生日应援到作品发布庆祝，从线下聚会到线上联动，每一次活动都是粉丝们表达爱意的机会。</p>
    <h2>加入方式</h2>
    <p>通过本站注册即可加入桥本有菜官方粉丝社区。会员享有优先获取资讯、参与限定活动、购买限量周边等专属权益。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20community%20gathering%20with%20soft%20candlelight%20and%20elegant%20decor%2C%20cozy%20atmosphere%2C%20cream%20and%20rose%20gold%20tones%2C%20friendly%20social%20setting%2C%20minimalist%20interior%2C%20heartwarming%20photography&width=800&height=500&seq=article-community-01&orientation=landscape',
    date: '2026-08-05',
    tags: ['粉丝社区', '桥本有菜', '应援', '交流'],
    featured: false,
  },
  {
    id: 'article-7',
    title: '桥本有菜身材管理的秘密：饮食与运动习惯大公开',
    slug: 'hashimoto-arina-body-management',
    category: 'profile',
    excerpt: '桥本有菜如何在繁忙的工作中保持完美身材？本文为你揭晓她的饮食秘诀和运动习惯。',
    content: `<p>作为日本娱乐圈的顶级偶像，桥本有菜始终保持着令人羡慕的完美身材。166cm的身高搭配匀称的身材比例，让她在镜头前始终光彩照人。那么，她是如何在繁忙的工作中保持这样的状态呢？</p>
    <h2>饮食管理</h2>
    <p>桥本有菜曾在采访中透露，她非常注重饮食的均衡。每天的餐食以高蛋白、低脂肪为主，多吃鱼类、蔬菜和水果。她特别推荐日式传统饮食中的味噌汤和纳豆，认为这些发酵食品对肠道健康非常有益。</p>
    <h2>运动习惯</h2>
    <p>尽管工作繁忙，桥本有菜每周至少保持三次运动。她的运动项目包括普拉提、瑜伽和有氧运动。她表示，普拉提对于塑造身体线条特别有效，而瑜伽则帮助她缓解工作压力。</p>
    <h2>护肤心得</h2>
    <p>除了身材管理，桥本有菜的护肤心得也备受关注。她强调防晒是最重要的护肤步骤，无论晴天阴天都会涂抹防晒霜。此外，她每天保证充足的睡眠时间，认为"美容觉"是保持肌肤状态的关键。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Healthy%20lifestyle%20with%20fresh%20fruits%20and%20yoga%20mat%2C%20soft%20natural%20light%2C%20cream%20and%20sage%20green%20tones%2C%20minimalist%20wellness%20aesthetic%2C%20clean%20composition%2C%20zen%20atmosphere&width=800&height=500&seq=article-profile-02&orientation=landscape',
    date: '2026-07-30',
    tags: ['身材管理', '桥本有菜', '饮食', '运动'],
    featured: false,
  },
  {
    id: 'article-8',
    title: '桥本有菜的时尚穿搭进化史',
    slug: 'hashimoto-arina-fashion-evolution',
    category: 'news',
    excerpt: '回顾桥本有菜出道至今的时尚穿搭变迁，从甜美少女到优雅女性的风格转变。',
    content: `<p>桥本有菜的时尚穿搭风格随着她的成长不断进化。从出道初期的甜美少女风，到如今的优雅知性风，她的每一次亮相都令人眼前一亮。</p>
    <h2>出道初期：甜美少女风</h2>
    <p>刚出道时的桥本有菜偏爱蕾丝、蝴蝶结等少女元素，色彩上以粉色、白色等柔和色调为主，展现出青春活力的少女形象。</p>
    <h2>转型期：轻熟优雅风</h2>
    <p>随着事业的发展，桥本有菜的风格逐渐向成熟方向转变。她开始尝试更多简约大气的搭配，用基础的剪裁和高级的面料展现气质。</p>
    <h2>现在：多元化时尚icon</h2>
    <p>如今的桥本有菜已经成为日本时尚圈的重要icon。她能够轻松驾驭各种风格，从街头休闲到红毯礼服，每一次亮相都展现出独特的时尚品味。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20wardrobe%20with%20soft%20fabric%20textures%2C%20warm%20cream%20and%20rose%20tones%2C%20minimalist%20clothing%20rack%2C%20chic%20boutique%20atmosphere%2C%20natural%20lighting%2C%20sophisticated%20fashion%20photography&width=800&height=500&seq=article-fashion-01&orientation=landscape',
    date: '2026-07-22',
    tags: ['时尚', '穿搭', '桥本有菜', '风格'],
    featured: false,
  },
  {
    id: 'article-9',
    title: '桥本有菜写真集《夏の記憶》回顾：夏日限定的美好',
    slug: 'hashimoto-arina-photobook-summer-memory',
    category: 'photobook',
    excerpt: '回顾桥本有菜2025年发布的写真集《夏の記憶》，在冲绳的碧海蓝天下记录的最美瞬间。',
    content: `<p>《夏の記憶》是桥本有菜于2025年夏季发布的写真集，在冲绳取景拍摄。这本写真集以"夏日记忆"为主题，用镜头记录了桥本有菜在冲绳碧海蓝天下的每一个美丽瞬间。</p>
    <h2>拍摄地点</h2>
    <p>写真集主要在冲绳本岛及周边离岛取景。从古宇利岛的蓝色大海到万座毛的壮丽断崖，从国际通的繁华街市到静谧的乡间小路，冲绳的多样风光与桥本有菜的魅力交相辉映。</p>
    <h2>概念设计</h2>
    <p>《夏の記憶》以"一期一会"为设计理念，强调夏日限定的美好与珍贵。每一页都仿佛在诉说一个关于夏天的故事，让人感受到青春、自由与梦想的气息。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20tropical%20beach%20scene%20with%20soft%20golden%20sunset%20light%2C%20ocean%20waves%2C%20cream%20and%20coral%20tones%2C%20peaceful%20summer%20atmosphere%2C%20minimalist%20composition%2C%20artistic%20landscape%20photography&width=800&height=500&seq=article-photobook-02&orientation=landscape',
    date: '2026-07-18',
    tags: ['写真集', '夏日记忆', '桥本有菜', '冲绳'],
    featured: false,
  },
  {
    id: 'article-10',
    title: '桥本有菜在综艺节目中的精彩表现盘点',
    slug: 'hashimoto-arina-variety-show-highlights',
    category: 'works',
    excerpt: '盘点桥本有菜在各大综艺节目中的精彩表现，从搞笑笑场到感人瞬间，展现她不为人知的多样魅力。',
    content: `<p>除了在影视作品中的出色表现，桥本有菜在综艺节目中也展现出了令人惊喜的综艺感和真实性格。本文盘点了她在各大综艺节目中的精彩表现。</p>
    <h2>搞笑天赋</h2>
    <p>让人意外的是，外表甜美的桥本有菜在综艺节目中展现出了极强的搞笑天赋。她不怕扮丑、不惧自黑，自然的反应和机智的接梗能力让观众看到了她完全不同的一面。</p>
    <h2>真挚情感</h2>
    <p>在谈话类综艺中，桥本有菜也多次展现了她细腻真挚的一面。谈到家人、粉丝和事业时流露出的真情实感，让无数观众为之动容。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20colorful%20lights%20and%20warm%20atmosphere%2C%20entertainment%20show%20aesthetic%2C%20soft%20cream%20and%20rose%20gold%20tones%2C%20professional%20studio%20photography%2C%20lively%20yet%20elegant&width=800&height=500&seq=article-variety-01&orientation=landscape',
    date: '2026-07-15',
    tags: ['综艺节目', '桥本有菜', '精彩表现', '搞笑'],
    featured: false,
  },
];

export const works = [
  {
    id: 'work-1',
    title: '花与少女',
    type: '影视作品',
    year: '2025',
    description: '桥本有菜主演的浪漫爱情电影，讲述了一段发生在京都的唯美爱情故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20movie%20poster%20style%20with%20soft%20cherry%20blossom%20petals%2C%20romantic%20warm%20pink%20and%20cream%20tones%2C%20minimalist%20film%20aesthetic%2C%20Japanese%20romance%20cinema&width=600&height=400&seq=work-01&orientation=landscape',
  },
  {
    id: 'work-2',
    title: '东京恋歌',
    type: '影视作品',
    year: '2024',
    description: '以东京为背景的都市爱情故事，桥本有菜饰演一位追求音乐梦想的年轻女性。',
    coverImage: 'https://readdy.ai/api/search-image?query=Tokyo%20cityscape%20at%20twilight%20with%20warm%20golden%20lights%2C%20romantic%20urban%20atmosphere%2C%20soft%20cream%20and%20amber%20tones%2C%20cinematic%20city%20photography&width=600&height=400&seq=work-02&orientation=landscape',
  },
  {
    id: 'work-3',
    title: '星空下的约定',
    type: '影视作品',
    year: '2024',
    description: '一部关于青春、梦想与友情的感人作品，桥本有菜的演技获得广泛好评。',
    coverImage: 'https://readdy.ai/api/search-image?query=Starry%20night%20sky%20with%20soft%20glowing%20stars%2C%20dreamy%20romantic%20atmosphere%2C%20cream%20and%20navy%20tones%2C%20minimalist%20celestial%20aesthetic%2C%20cinematic%20night%20scene&width=600&height=400&seq=work-03&orientation=landscape',
  },
  {
    id: 'work-4',
    title: '彩虹桥',
    type: '综艺节目',
    year: '2025',
    description: '桥本有菜担任常驻嘉宾的人气综艺节目，展现了她真实可爱的一面。',
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%20TV%20variety%20show%20set%20with%20bright%20warm%20lights%2C%20entertainment%20studio%20atmosphere%2C%20cream%20and%20coral%20tones%2C%20playful%20professional%20setting&width=600&height=400&seq=work-04&orientation=landscape',
  },
  {
    id: 'work-5',
    title: '晨间剧《向日葵》',
    type: '电视剧',
    year: '2023',
    description: '桥本有菜首次出演晨间剧，饰演女主角的闺蜜，清新自然的演技获得好评。',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20morning%20sunlight%20through%20window%20with%20sunflowers%2C%20gentle%20cream%20and%20yellow%20tones%2C%20cozy%20home%20atmosphere%2C%20Japanese%20drama%20aesthetic%2C%20soft%20natural%20lighting&width=600&height=400&seq=work-05&orientation=landscape',
  },
  {
    id: 'work-6',
    title: '深夜时分',
    type: '广播节目',
    year: '2025',
    description: '桥本有菜主持的深夜广播节目，与听众分享音乐、生活感悟与幕后故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20radio%20studio%20at%20night%20with%20warm%20dim%20lighting%2C%20vintage%20microphone%2C%20cream%20and%20amber%20tones%2C%20intimate%20broadcasting%20atmosphere%2C%20professional%20audio%20setting&width=600&height=400&seq=work-06&orientation=landscape',
  },
];

export const photobooks = [
  {
    id: 'pb-1',
    title: '花季',
    releaseDate: '2026-07-15',
    description: '在京都取景的最新写真集，融合千年古都风情与现代女性魅力。',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20photo%20book%20cover%20with%20cherry%20blossom%20design%2C%20soft%20pink%20and%20cream%20tones%2C%20minimalist%20layout%2C%20delicate%20aesthetic%2C%20artistic%20book%20cover%20design%2C%20Kyoto%20theme&width=500&height=650&seq=pb-01&orientation=portrait',
  },
  {
    id: 'pb-2',
    title: '夏の記憶',
    releaseDate: '2025-08-20',
    description: '冲绳取景的夏日主题写真集，碧海蓝天下的绝美瞬间。',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20photo%20book%20cover%20with%20ocean%20and%20summer%20theme%2C%20soft%20coral%20and%20cream%20tones%2C%20tropical%20minimalist%20design%2C%20artistic%20book%20cover%2C%20Okinawa%20beach%20aesthetic&width=500&height=650&seq=pb-02&orientation=portrait',
  },
  {
    id: 'pb-3',
    title: '素顔',
    releaseDate: '2024-12-01',
    description: '以"真实的桥本有菜"为主题的写真集，记录日常生活中的自然瞬间。',
    coverImage: 'https://readdy.ai/api/search-image?query=Natural%20portrait%20style%20photo%20book%20cover%2C%20minimalist%20cream%20and%20beige%20tones%2C%20soft%20natural%20lighting%2C%20elegant%20simple%20design%2C%20artistic%20book%20cover%2C%20intimate%20aesthetic&width=500&height=650&seq=pb-03&orientation=portrait',
  },
  {
    id: 'pb-4',
    title: '東京散歩',
    releaseDate: '2024-06-10',
    description: '在东京各处取景的城市漫步写真集，记录都市女性的日常之美。',
    coverImage: 'https://readdy.ai/api/search-image?query=Tokyo%20city%20theme%20photo%20book%20cover%2C%20warm%20urban%20golden%20and%20cream%20tones%2C%20modern%20minimalist%20design%2C%20elegant%20book%20cover%2C%20city%20lifestyle%20aesthetic&width=500&height=650&seq=pb-04&orientation=portrait',
  },
];

export const aboutInfo = {
  brandName: '桥本有菜官方资料站',
  brandIntro: '桥本有菜官方资料站创立于2020年，是中文互联网上最全面、最权威的桥本有菜资讯平台。我们致力于为华语地区的粉丝提供桥本有菜的个人资料、作品资讯、写真集、最新动态等全方位信息服务。',
  mission: '我们的使命是搭建一座连接桥本有菜与华语粉丝的桥梁，让每一位喜欢桥本有菜的朋友都能在这里找到最全面、最及时的信息。',
  reputation: [
    { label: '累计访问', value: '1,280万+' },
    { label: '粉丝社群', value: '32万+' },
    { label: '文章数量', value: '1,500+' },
    { label: '运营年限', value: '6年+' },
  ],
  contact: {
    email: 'contact@hashimoto-arina.com',
    address: '日本东京都港区',
    weibo: '@桥本有菜粉丝站',
  },
};

export const featuredArticles = articles.filter((a) => a.featured);